<template>
  <div id="app">
    <header>
      <b-navbar v-if="showHeader" toggleable="lg" type="light" variant="light">
        <b-navbar-brand @click="activeSidebar = !activeSidebar">
          <b-link>
            <span class="navbar-toggler-icon"></span>
          </b-link>
        </b-navbar-brand>

        <b-navbar-brand href="#">
          <img src="./assets/mcIcon.png" style="width:50px">
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse">
          <template #default="{ expanded }">
            <b-icon v-if="expanded" icon="chevron-bar-up"></b-icon>
            <b-icon v-else icon="chevron-bar-down"></b-icon>
          </template>
        </b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item left>{{usuario.cz10_nome}}</b-nav-item>
            <b-nav-item @click="sair" left>Sair</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </header>
    <Sidebar v-if="showHeader" :usuario="usuario.cz10_nome" :activeSidebar="activeSidebar" @close="close"/>
    <main>
      <router-view @is-login="isLogin" @is-not-login="isNotLogin"></router-view>
    </main>
    <b-container v-if="mostra">
      <b-row>
        <b-col class="mx-auto text-center mb-2 mt-2">
          <div class="bg-secondary text-white">
            Instale esse APP no seu Iphone: Aperte em <img src="./assets/share.png" style="width:20px">
            e então "Adicionar à Tela de Início"
          </div>
        </b-col>
      </b-row>
    </b-container>
    <section class="app-footer">
      <footer id="footer" class="footer bg-light pt-2 pb-2" v-if="showFooter">
        <div class="container-fluid clearfix">
          <span class="text-muted d-block text-center text-sm-left d-sm-inline-block">© 2020 MC Informática<br>
          </span>
          <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">
            <a href="mailto:sistema@mcinfor-saude.com.br" class="text-muted">
              sistema@mcinfor-saude.com.br
            </a><br>
            <a href="tel:32239426" class="text-muted">
              3223-9426
            </a>
          </span>
        </div>
      </footer>
    </section>

  </div>
</template>

<script>
import Sidebar from './components/Sidebar'
export default {
  components: { Sidebar },
  name: 'app',
  data () {
    return {
      activeSidebar: false,
      active: true,
      mostra: false,
      showHeader: true,
      showFooter: false,
      usuario: ''
    }
  },
  created () {
    if (localStorage.usuarioMC !== '' && localStorage.usuarioMC !== undefined && localStorage.usuarioMC !== 'undefined') {
      const obj = JSON.parse(localStorage.usuarioMC)
      const usuario = obj.usuario
      this.usuario = usuario
    }
  },
  mounted () {
    // Detecta se o dispositivo está no iOS
    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase()
      return /iphone|ipad|ipod/.test(userAgent)
    }
    // Detects if device is in standalone mode
    const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone)
    // Verifica se deve exibir notificação popup de instalação:
    if (isIos() && !isInStandaloneMode()) {
      // this.setState({ showInstallMessage: true })
      this.mostra = true
    }
  },
  methods: {
    close () {
      this.activeSidebar = false
    },
    isLogin () {
      this.showHeader = false
      this.showFooter = true
    },
    isNotLogin () {
      this.showHeader = true
      this.showFooter = false
      if (localStorage.usuarioMC !== '' && localStorage.usuarioMC !== undefined && localStorage.usuarioMC !== 'undefined') {
        const obj = JSON.parse(localStorage.usuarioMC)
        const usuario = obj.usuario
        this.usuario = usuario
      }
    },
    sair () {
      localStorage.usuarioMC = undefined
      this.$router.push({name: 'Login'})
    }
  }
}
</script>

<style>
body {
  margin: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

main {
  margin-top: 40px;
}
.app-footer {
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
}
.btn-primary {
    /*background-color: #007bff;
    border-color: #007bff; */
    background-image: -webkit-gradient(linear, left top, left bottom, from(#337ab7), to(#2e6da4));
    background: linear-gradient(to bottom, #337ab7 0%, #2e6da4 100%);
}
.bg-primary {
  background: linear-gradient(to bottom, #337ab7 0%, #2e6da4 100%);
}
a:hover {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue